import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import { nftDataRes } from '@/api/server/nft/collections';
import { useEffect, useState } from 'react';
import { OwnedNft } from 'alchemy-sdk';

export type collectionListProps = {
  contract: string;
  allNftList: OwnedNft[];
  setSelectNft: (value: OwnedNft) => void;
  setIsCollection: (value: boolean) => void;
  onClick?: () => void;
};
export default function CollectionList({ contract, allNftList, setSelectNft, setIsCollection }: collectionListProps) {
  const [select, setSelect] = useState<OwnedNft[]>([]);

  useEffect(() => {
    const re = allNftList.filter((item: OwnedNft) => item.contract.address === contract);
    setSelect(re);
    return () => {};
  }, [contract]);

  return (
    <>
      <Stack direction="row" gap={1.5} overflow="scroll">
        {select.map((item: OwnedNft, index: number) => {
          return (
            <Box key={`collection-list-${index}-${item.contract.name}`}>
              <Box fontWeight={700} textAlign="center">
                {item.tokenId}
              </Box>
              <IconButton
                onClick={() => {
                  setSelectNft(item);
                  setIsCollection(true);
                }}
                sx={{ p: 0 }}
              >
                <img src={item.image?.cachedUrl} width={100} height={100} alt={item.contract.name} />
              </IconButton>
            </Box>
          );
        })}
      </Stack>
    </>
  );
}
